<confirm
  #deleteConfirm
  (modalClosed)="cancel()"
  (confirmOutput)="deleteFile($event)"
  [title]="'common.delete-confirmation' | translate"
  [message]="'plugins.add-attachements.sure-to-delete' | translate"
  [danger]="true"
></confirm>
